import './bootstrap';
import 'preline';
import ClipboardJS from 'clipboard';

// Make rotatingNotice globally available for inline Alpine usage
window.rotatingNotice = function(elOrOptions = {}) {
  let messages = [];
  let interval = 4000;

  if (elOrOptions instanceof Element) {
    try {
      messages = JSON.parse(elOrOptions.dataset.messages || '[]');
    } catch (e) {
      messages = [];
    }
    interval = parseInt(elOrOptions.dataset.interval) || interval;
  } else if (typeof elOrOptions === 'object') {
    messages = elOrOptions.messages || [];
    interval = elOrOptions.interval || interval;
  }

  return {
    messages: messages || [],
    index: 0,
    timer: null,
    interval: interval,
    init() {
      if (!this.messages || this.messages.length === 0) return;
      this.play();
    },
    play() {
      this.stop();
      this.timer = setInterval(() => { this.next(); }, this.interval);
    },
    stop() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    },
    pause() { this.stop(); },
    next() { if (this.messages && this.messages.length) { this.index = (this.index + 1) % this.messages.length; } }
  }
};
/*
document.addEventListener('DOMContentLoaded', function () {
    const topNav = document.getElementById('topNav');
    const mainNav = document.getElementById('mainNav');
    let lastScrollTop = 0;
    let middleScroll = 2.2;

    window.addEventListener('scroll', function () {
        let scrollTop = window.scrollY || document.documentElement.scrollTop;
        let scrollThreshold = 100;

        if (scrollTop > lastScrollTop) {
            // Scrolling down
            if(topNav)
            {
            topNav.classList.add('hidden');
            }
            if(mainNav)
            {   
            mainNav.classList.remove('relative');
            mainNav.classList.add('fixed');
            mainNav.style.top = '0rem';
            }
        } 
        else 
        {
            if(topNav)
             {
            topNav.classList.remove('hidden');
             }
           
            if (scrollTop <= scrollThreshold) 
            {
                if(mainNav)
                 { 
                mainNav.style.top = '2.2rem'; 
                 }
            } 
            else
            {
                if(mainNav)
                 { 
                mainNav.style.top = '0';
                 }
            }
        }

        lastScrollTop = scrollTop;

    });
});
*/

  // INITIALIZATION OF CLIPBOARD
  // =======================================================
  (function() {
    window.addEventListener('load', () => {
      const $clipboards = document.querySelectorAll('.js-clipboard-example');
      if (!window.HSStaticMethods || !window.HSTooltip) return;
      $clipboards.forEach((el) => {
        const isToggleTooltip = HSStaticMethods.getClassProperty(el, '--is-toggle-tooltip') === 'false' ? false : true;
        const clipboard = new ClipboardJS(el, {
          text: (trigger) => {
            const clipboardText = trigger.dataset.clipboardText;

            if (clipboardText) return clipboardText;

            const clipboardTarget = trigger.dataset.clipboardTarget;
            const $element = document.querySelector(clipboardTarget);

            if (
              $element.tagName === 'SELECT'
              || $element.tagName === 'INPUT'
              || $element.tagName === 'TEXTAREA'
            ) return $element.value
            else return $element.textContent;
          }
        });
        clipboard.on('success', () => {
          const $default = el.querySelector('.js-clipboard-default');
          const $success = el.querySelector('.js-clipboard-success');
          const $successText = el.querySelector('.js-clipboard-success-text');
          const successText = el.dataset.clipboardSuccessText || '';
          const tooltip = el.closest('.hs-tooltip');
          const $tooltip = HSTooltip.getInstance(tooltip, true);
          let oldSuccessText;

          if ($successText) {
            oldSuccessText = $successText.textContent
            $successText.textContent = successText
          }
          if ($default && $success) {
            $default.style.display = 'none'
            $success.style.display = 'block'
          }
          if (tooltip && isToggleTooltip) HSTooltip.show(tooltip);
          if (tooltip && !isToggleTooltip) $tooltip.element.popperInstance.update();

          setTimeout(function () {
            if ($successText && oldSuccessText) $successText.textContent = oldSuccessText;
            if (tooltip && isToggleTooltip) HSTooltip.hide(tooltip);
            if (tooltip && !isToggleTooltip) $tooltip.element.popperInstance.update();
            if ($default && $success) {
              $success.style.display = '';
              $default.style.display = '';
            }
          }, 800);
        });
      });
    });
  })();

// INITIALIZATION OF OF LOADER PLACEHOLDER
// =======================================================
    (function () {
      var visibleAfterLoadMs = 2500;

      function showContent() {
        var content = document.getElementById('dashboard-page-content');

        if (!content) {
          return;
        }

        content.classList.remove('opacity-0', 'pointer-events-none');
      }

      function hideLoader() {
        var loader = document.getElementById('dashboard-page-loader');

        window.setTimeout(function () {
          showContent();

          if (!loader) {
            return;
          }

          loader.classList.add('opacity-0', 'pointer-events-none');

          window.setTimeout(function () {
            loader.remove();
          }, 320);
        }, visibleAfterLoadMs);
      }

      if (document.readyState === 'complete') {
        hideLoader();
        return;
      }

      window.addEventListener('load', hideLoader, { once: true });
    })();